// Central Amden Compass route configuration — the single place to change the
// canonical marketing URL and the tracked enquiry/booking links. Page content
// itself lives in the CMS (cms_listings, slug "amden-compass").
import { getEcosystemItems } from './ecosystem';

export const COMPASS_ROUTE = '/systems/compass';
export const COMPASS_LISTING_SLUG = 'amden-compass';

const TRACKING = 'interest=amden-compass&source=Compass%20Product%20Page';
export const COMPASS_DEMO_HREF = `/contact?${TRACKING}#book-appointment`;
export const COMPASS_PRICING_HREF = `/contact?${TRACKING}&topic=pricing#contact-enquiry`;

export const getCompass = () =>
  getEcosystemItems().find((it) => it.slug === COMPASS_LISTING_SLUG) || null;
